import React, {PureComponent} from 'react';
import ArrowIcon from "./ArrowIcon";
import PropTypes from "prop-types";
import './style.scss';

class FormDropdown extends PureComponent{
    state={
        listOpen: false
    }

    toggleDropdown = e => {
        e.stopPropagation();
        this.setState(prevState => ({ listOpen: !prevState.listOpen }));
    };

    closeDropdown = e => {
        e.stopPropagation();
        setTimeout(()=>this.setState({listOpen: false}), 200);
    }

    render(){

        const {list,name,onChange, value, label, error} = this.props;

        let dropdownList = list.map((e, i)=>{
            let classes = `dropdown-option ${e === value ? 'dropdown-selected' : ''}`
            return <input className={classes} key={e} name={name} value={e} onClick={onChange} readOnly/>
        })

        let listContent = <ul className='dropdown-content'>
            {this.state.listOpen? dropdownList : null}
        </ul>

        let dropdownValue = <p className='dropdown-value'>{value}</p>

        return <div className='dropdown-container' onClick={this.toggleDropdown} onMouseLeave={this.closeDropdown}>
            <div className="dropdown-left">
                <span className='dropdown-title'>{label}</span>
                {this.state.listOpen ? listContent : dropdownValue}
            </div>
            <div className="dropdown-right">
                {error ? <span className="error">{error}</span> : null}
                <span className='dropdown-arrow'>
                <ArrowIcon listOpen={this.state.listOpen} />
                </span>
            </div>
        </div>
    }
}

FormDropdown.propTypes = {
    list: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string,PropTypes.number])
}

export default FormDropdown;